<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

<div *ngIf="parentData.data">
  <div style="text-align: center;">
    <img style="width: 100%;" [src]="parentData.data.documentThumbUrl" alt="" />
  </div>
  <div>
    <div style="margin-bottom: 10px;" class="row">
        <div class="col-sm-12">
            <h2 style="margin-bottom: 4px;">{{ parentData.data.documentName }}</h2>
            <p>{{ parentData.data.documentDescription }}</p>
        </div>
      
    </div>
    <div>
        <mat-icon class="material-icons-outlined">calendar_month</mat-icon> <span style="    position: relative;
        top: -7px;
        margin-left: 10px;    color: #9a9a9a;
    font-weight: 500;">Uploaded at:</span>
        <p style="margin-left: 34px;">{{parentData.data.creationDate | date: "mediumDate"}}</p>
        <mat-icon class="material-icons-outlined">verified</mat-icon> <span style="    position: relative;
        top: -7px;
        margin-left: 10px;    color: #9a9a9a;
    font-weight: 500;">Verification status:</span>
        <p style="margin-left: 34px;">{{parentData.data.verificationStat}}</p>
    </div>
  </div>
</div>
